<template>
  <div id="register" v-html="$t('privacy')">
    
  </div>
</template>

<script>
import HeaderTop from "../assembly/HeaderTop";
import HeaderTitle from "../assembly/HeaderTitle";
import Footer from "../assembly/Footer";

export default {
  name: "register",
  data() {
    return {};
  },
  created() {},
  methods: {},
  components: {},
};
</script>

<style scoped>
#register {
    max-width: 1200px;
    margin: 0 auto;
  text-align: left;
  padding: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy/privacy.vue